import { render, staticRenderFns } from "./HotDetails.vue?vue&type=template&id=9dfbc912&scoped=true&"
import script from "./HotDetails.vue?vue&type=script&lang=js&"
export * from "./HotDetails.vue?vue&type=script&lang=js&"
import style0 from "./HotDetails.vue?vue&type=style&index=0&id=9dfbc912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfbc912",
  null
  
)

export default component.exports